import { useMemo } from 'react';

import { validator } from './validators';

import type { ErrorFields, UseValidationProps, UseValidation } from './types';

export const useValidation = ({ configurationFields, data }: UseValidationProps): UseValidation => {
  const errors = useMemo((): ErrorFields => {
    if (!configurationFields) return {};
    if (!data) return {};

    return Object.keys(configurationFields).reduce((faultyFields: ErrorFields, fieldKey) => {
      const error = validator(configurationFields[fieldKey], data[fieldKey]);
      if (error) {
        return {
          ...faultyFields,
          [fieldKey]: error,
        };
      }
      return faultyFields;
    }, {});
  }, [data, configurationFields]);

  return {
    errors,
    isValid: Object.keys(errors).length === 0,
  };
};
